<template>
  <div style="background-color: white; display: inline-block; width: 100%;">
    <transition name="fade-in-up">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RegisterLayout",
  components: {
    
  },
  beforeMount() {
    
  },
  mounted() {
    
  },
  methods: {},
  computed: {
    ...mapGetters([
      "currentUser",
      "isAuthenticated",
    ]),
  }
};
</script>
<style>
html, body {
  background: #ffffff !important;
  margin: 0;
  padding: 0;
  height: auto !important;
  min-height: 0 !important;
  overflow: visible !important;
}

body > div {
  display: inline-block;
  width: 100%;
}
</style>